import React from 'react';

const AgentInternalFlags = ({
  visible,
  formData,
  onChange,
  disabled = false,
}) => {
  if (!visible) return null;

  const handlePartyLinkedCheck = (e) => {
    onChange({
      target: { name: 'commission_enabled', type: 'checkbox', checked: e.target.checked },
    });
  };

  return (
    <div className="col-span-2 sm:col-span-2 lg:col-span-5 grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4 mt-1">
      <label className="flex items-start gap-2 p-3 rounded-xl border border-gray-200 bg-gray-50">
        <input
          type="checkbox"
          name="commission_enabled"
          checked={Boolean(formData.commission_enabled)}
          onChange={handlePartyLinkedCheck}
          disabled={disabled}
          className="mt-0.5 w-4 h-4 text-blue-600 border-gray-300 rounded"
        />
        <span>
          <span className="block text-sm font-medium text-gray-800">Calculate commission</span>
          <span className="block text-xs text-gray-500">
            Auto-on when a contract party is selected. Own-company agents can also opt in. Off means no commission.
          </span>
        </span>
      </label>
      <label className="flex items-start gap-2 p-3 rounded-xl border border-gray-200 bg-gray-50">
        <input
          type="checkbox"
          name="is_pickup_man"
          checked={Boolean(formData.is_pickup_man)}
          onChange={onChange}
          disabled={disabled}
          className="mt-0.5 w-4 h-4 text-blue-600 border-gray-300 rounded"
        />
        <span>
          <span className="block text-sm font-medium text-gray-800">Pickup man</span>
          <span className="block text-xs text-gray-500">
            Same Agent role with simplified running-mode booking. Auto-ML only
            appends an existing same-day sheet. Create ML is hidden.
          </span>
        </span>
      </label>
    </div>
  );
};

export default AgentInternalFlags;
